import React from 'react';
import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';

const GeneralPageLayout = ({
  children = null,
  bookmark = null,
  sectionTypeText = '',
  sectionTitleText = '',
  footerText = '',
  textColor = null,
  backgroundColor = null,
}): JSX.Element => {
  const Styles = StyleSheet.create({
    contentView: {
      padding: 36.5,
      backgroundColor: backgroundColor || 'black',
      color: textColor || 'white',
    },
    headerView: {
      width: '100%',
      height: '7.5%',
    },
    announcement: {
      fontFamily: 'Courier',
      textTransform: 'uppercase',
      fontSize: 12,
    },
    announcementTheme: {
      fontFamily: 'Times-Roman',
      fontSize: 30,
      lineHeight: 1.17,
    },
    bodyView: {
      width: '100%',
      height: '90%',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
    },
    footerView: {
      width: '100%',
      height: '2.5%',
      fontFamily: 'Courier',
      fontSize: 8,
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'flex-end',
      justifyContent: 'space-between',
    }
  });

  // _.each(Styles, (style) => {
  //   style['border'] = '1px solid magenta';
  // });  

  return (
    // @ts-expect-error: despite the error, bookmark is in the documentation https://react-pdf.org/advanced#bookmarks
    <Page size="LETTER" bookmark={bookmark}>
      <View style={Styles.contentView}>
        <View style={Styles.headerView}>
          <View style={Styles.announcement}>
            <Text>{sectionTypeText}</Text>
          </View>
          <View style={Styles.announcementTheme}>
            <Text>{sectionTitleText}</Text>
          </View>
        </View>
        <View style={Styles.bodyView}>
          {children}
        </View>
        <View style={Styles.footerView}>
          <Text>{footerText}</Text>
          <Text>©2022–{new Date().getFullYear()} radian™ by Lightbeam Health Solutions.</Text>
        </View>
      </View>
    </Page>
  );
};

export default GeneralPageLayout;
